import { isoZ, z } from 'my-zod'
import { StrictLanguageEnum } from '../../internal'
import { additionalWaiverQuestionResponse } from './additional-waiver-question-response'

export const customerWaiverModel = z.object({
  id: z.string().uuid(),
  operatorId: z.number(),
  language: StrictLanguageEnum,
  proposedRideDate: isoZ.date().nullable(),

  firstName: z.string().min(1),
  lastName: z.string().min(1),
  birthDate: isoZ.date(),
  email: z.string().min(1),
  primaryPhone: z.string().min(1),

  addressLine1: z.string().min(1),
  addressLine2: z.string().nullable(),
  city: z.string().min(1),
  state: z.string().min(1),
  postalCode: z.string().min(1),
  country: z.string().min(1),

  driverLicenseNumber: z.string().min(1),
  driverLicenseState: z.string().min(1),

  firstTimeRider: z.boolean(),
  hasMotorcycleLicense: z.boolean(),
  additionalEmailOptIn: z.boolean(),

  outfitterWaiverContentId: z.string().min(1),
  outfitterWaiverContentVersionId: z.number(),

  additionalWaiverQuestionResponses: additionalWaiverQuestionResponse.array(),
  waiverFormSnapshotUrl: z.string().min(1),

  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant()
})
